export default "__VITE_ASSET__DeR6VdjW__"